// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__DC0iN","productName":"Table_productName__2weh-"};